module.exports = __webpack_public_path__ + "static/media/Roboto-Black.f3fa86ed.ttf";